export default __webpack_public_path__ + "static/media/kakaotalk.db1bf2a3.mp3";